import React, { Fragment } from 'react';

export const Loader = () => (
    <Fragment>Loading<span>.</span><span>.</span><span>.</span></Fragment>
);
